import { findRecord } from "./services.js";
import { toJalaali, jalaaliToDateObject } from "jalaali-js";

async function getUserDashboard(userId) {
  let data = {
    inventory: 0,
    tourCount: 0,
    buyCount: 0,
    ticketCount: 0,
  };
  let res = await findRecord("wallets", {
    conditions: `uid/=/${userId}`,
    fields: "current_inventory",
  });
  if (res.length > 0) data.inventory = parseInt(res[0].current_inventory);
  res = await findRecord("tour_reservation_items", {
    conditions: `uid/=/${userId}`,
    fields: "COUNT(id) as tourCount",
  });
  if (res.length > 0) data.tourCount = parseInt(res[0].tourCount);

  return data;
}

async function getAdminDashboard() {
  let data = {
    allMembers: 0,
    thisMonthMembers: 0,
    activeTourCounts: 0,
    allRemainingCapacity: 0,
    uncompletedReserves: 0,
    withdrawCount: 0,
    customersInventory: 0,
  };

  // allMembers
  let res = await findRecord("users", {
    conditions: "isadmin/=/0",
    fields: "COUNT(id) as count",
  });
  if (res.length > 0) data.allMembers = parseInt(res[0].count);

  // thisMonthMembers
  let date = toJalaali(new Date());
  date = jalaaliToDateObject(date.jy, date.jm, 1);
  date = Math.floor(date.getTime() / 1000);
  res = await findRecord("users", {
    conditions: `isadmin/=/0@@mtm/>/${date}`,
    fields: "COUNT(id) as count",
  });
  data.thisMonthMembers = res.length;

  res = await findRecord("tours", {
    conditions: "main_status/=/4",
    fields:
      "SUM(main_capacity - complate_reserved - frozen_reserved) as remaining, COUNT(id) as count, SUM(frozen_reserved) as frozen",
  });
  if (res.length > 0) {
    data.activeTourCounts = parseInt(res[0].count);
    data.allRemainingCapacity = parseInt(res[0].remaining);
    data.uncompletedReserves = parseInt(res[0].frozen);
  }

  // TODO: data.uncompletedReserves

  res = await findRecord("wallets_transactions", {
    conditions: "type/=/3",
    fields: "COUNT(id) as count",
  });
  if (res.length > 0) data.withdrawCount = parseInt(res[0].count);

  res = await findRecord("wallets", {
    conditions: "type/=/0",
    fields: "SUM(current_inventory) as count",
  });
  if (res.length > 0) data.customersInventory = parseInt(res[0].count);

  return data;
}

export { getUserDashboard, getAdminDashboard };
